import React, { useState } from 'react';
import {
    Box,
    Typography,
    Card,
    IconButton,
    Button,
    Divider,
    Stack,
    FormControlLabel,
    Radio,
    FormControl,
    RadioGroup,
    FormLabel,
    TextField,
    Modal,
    CardContent,
    CardMedia,
    ToggleButtonGroup, ToggleButton, Chip
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import DeleteIcon from '@mui/icons-material/Delete';
import { CheckBox } from '@mui/icons-material';

import deals_1 from '../assets/deals_1.jpg';
import deals_2 from '../assets/deals_2.jpg';
import Header from '../components/header.tsx';
import StarRating from '../components/star_ratings.tsx';
import AccessTimeFilledIcon from '@mui/icons-material/AccessTimeFilled';
import EastIcon from '@mui/icons-material/East';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import EditIcon from '@mui/icons-material/Edit';
import Footer from '../components/footer.tsx';
import deals_3 from '../assets/deals_3.jpg';
import deals_4 from '../assets/deals_4.jpg';
import deals_5 from '../assets/deals_5.jpg';
import { ReactComponent as SparkIco } from '../assets/svg/spark.svg';
import { useNavigate } from 'react-router-dom';

const initialItems = [
    {
        id: 1,
        name: 'Tablet',
        price: 49.99,
        oldPrice: 59.99,
        quantity: 2,
        image: deals_1,
        availability: 'In Stock',
        rating: 4
    },
    {
        id: 2,
        name: 'Wireless Headphone',
        price: 29.99,
        oldPrice: 49.99,
        quantity: 1,
        image: deals_2,
        availability: 'In Stock',
        rating: 3.5
    },
];

const Cart = () => {

    const navigate = useNavigate();
    const [deliveryselectedOption, setSelectedDeliveryOption] = useState("standard");
    const [items, setItems] = useState(initialItems);
    const [changeAddress, setChangeAddress] = useState(false);
    const [newaddress, setNewAddress] = useState(false);
    const [toggle, setToggle] = useState('save');

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '40%',
        bgcolor: 'background.paper',
        boxShadow: 24,
        p: 4,
        borderRadius: 2,
        maxHeight: '90vh',
        overflowY: 'auto'
    };

    const handleIncrease = (id: number) => {
        setItems((prev) =>
            prev.map((item) =>
                item.id === id
                    ? { ...item, quantity: item.quantity + 1 }
                    : item
            )
        );
    };

    const handleDecrease = (id: number) => {
        setItems((prev) =>
            prev.map((item) =>
                item.id === id
                    ? {
                        ...item,
                        quantity: item.quantity > 1 ? item.quantity - 1 : item.quantity,
                    }
                    : item
            )
        );
    };

    const handleDelete = (id: number) => {
        setItems((prev) => prev.filter((item) => item.id !== id));
    };

    const deliveryoptions = [
        {
            value: "standard",
            label: "Standard Delivery",
            subLabel: "Get it by Thursday, Jul 29",
            price: "Free",
        },
        {
            value: "express",
            label: "Express Delivery",
            subLabel: "Get it Tomorrow, Jul 25",
            price: "AED9.00",
        },
        {
            value: "today",
            label: "Same Day Delivery",
            subLabel: "Get it Today before 10PM",
            price: "AED19.00",
        },
    ];

    const dealsProduct = [
        {
            id: 1,
            discount: '-38%',
            price: 'AED499.99',
            oldPrice: 'AED799.99',
            title: 'Ultra HD Smart TV',
            size: '55"',
            endsIn: '12:45:00',
            image: deals_1,
        },
        {
            id: 2,
            discount: '-20%',
            price: 'AED299.99',
            oldPrice: 'AED379.99',
            title: 'Bluetooth Speaker',
            size: 'Compact',
            endsIn: '06:30:15',
            image: deals_2,
        },
        {
            id: 3,
            discount: '-45%',
            price: 'AED149.99',
            oldPrice: 'AED269.99',
            title: 'Wireless Headphones',
            size: 'Over-ear',
            endsIn: '03:12:50',
            image: deals_3,
        },
        {
            id: 4,
            discount: '-25%',
            price: 'AED59.99',
            oldPrice: 'AED79.99',
            title: 'Smartwatch Pro',
            size: '42mm',
            endsIn: '10:00:00',
            image: deals_4,
        },
        {
            id: 5,
            discount: '-50%',
            price: 'AED999.99',
            oldPrice: 'AED1999.99',
            title: 'Gaming Laptop',
            size: '15.6"',
            endsIn: '18:00:00',
            image: deals_5,
        },
    ];

    const saveForLaterItems = [
        {
            id: 101,
            name: 'Smartwatch Pro',
            price: 'AED59.99',
            oldPrice: "AED79.99",
            rating: 4.5,
            availability: 'In stock',
            image: deals_3,
            quantity: 1,
            discount: '-25%',
            size: "42mm"
        },
    ];

    const buyItAgainItems = [
        {
            id: 201,
            name: 'Wirelss Headphones',
            price: "AED1500.00",
            oldPrice: "AED2200.00",
            rating: 4,
            availability: 'In stock',
            image: deals_2,
            quantity: 1,
            discount: '-18%',
            size: 'compact'
        },
    ];

    return (
        <>
            {/* header */}
            <Header />
            {/* end header */}

            {/* body section */}
            <Box sx={{ padding: '3%' }}>
                {/* cart heading */}
                <Typography sx={{ fontSize: '26px', color: '#000', fontWeight: 'bold', mt: 1, display: 'flex', gap: '3px', alignItems: 'center' }}>Shopping Cart<span style={{ color: '#000', fontWeight: 'lighter', fontSize: '16px' }}>{`(${initialItems.length} Items)`}</span></Typography>
                {/* end cart heading */}

                {/* cart and other details */}
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: { xs: 'column', md: 'row' },
                        gap: 2,
                        mt: 2,
                    }}
                >
                    {/* left cards for cart items */}
                    <Box sx={{ flex: 2 }}>
                        {items.map((item) => (
                            <Card
                                key={item.id}
                                sx={{
                                    display: 'flex',
                                    mb: 2,
                                    p: 2,
                                    borderRadius: 2,
                                    boxShadow: 2,
                                }}
                            >
                                <Box
                                    component="img"
                                    src={item.image}
                                    alt={item.name}
                                    sx={{
                                        width: 80,
                                        height: 80,
                                        objectFit: 'cover',
                                        borderRadius: 1,
                                        mr: 2,
                                    }}
                                />
                                <Box flex={1}>
                                    <Typography fontWeight="bold">{item.name}</Typography>
                                    <Typography sx={{ fontWeight: 'bold', fontSize: '18px', color: '#C32032', display: 'flex', gap: '5px', alignItems: 'center' }}>
                                        <span>AED{item.price}</span>
                                        <span style={{ textDecoration: 'line-through', color: '#888', fontSize: '14px' }}>AED{item.oldPrice}</span>
                                    </Typography>
                                    <StarRating rating={item.rating} />
                                    <Typography fontWeight="bold" sx={{ color: 'green' }}>{item.availability}</Typography>
                                    {/* quantity */}
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            borderRadius: '30px',
                                            /*  px: 1, 
                                             py: 0.25, */
                                            width: 'fit-content',
                                            mt: 1,
                                            background: '#fff',
                                        }}
                                    >
                                        <IconButton
                                            sx={{
                                                background: '#C32032', p: 0.5, '&:hover': {
                                                    background: '#C32032',
                                                },
                                            }}
                                            size="small"
                                            onClick={() =>
                                                item.quantity === 1
                                                    ? handleDelete(item.id)
                                                    : handleDecrease(item.id)
                                            }
                                        >
                                            {item.quantity === 1 ? (
                                                <DeleteIcon sx={{ color: '#fff', fontSize: '16px' }} />
                                            ) : (
                                                <RemoveIcon sx={{ color: '#fff', fontSize: '16px' }} />
                                            )}
                                        </IconButton>

                                        <Typography sx={{ mx: 1, fontSize: '14px' }}>{item.quantity}</Typography>

                                        <IconButton
                                            sx={{
                                                background: '#C32032', p: 0.5, '&:hover': {
                                                    background: '#C32032',
                                                },
                                            }}
                                            size="small"
                                            onClick={() => handleIncrease(item.id)}
                                        >
                                            <AddIcon sx={{ color: '#fff', fontSize: '16px' }} />
                                        </IconButton>
                                    </Box>
                                    {/* end quantity */}
                                </Box>
                                <Box display="flex" flexDirection="column" justifyContent="center" gap={2}>
                                    <Typography sx={{ mx: 1, fontSize: '14px', '&:hover': { textDecoration: 'underline' }, cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '3px', color: 'gray' }}><AccessTimeFilledIcon sx={{ fontSize: '18px', color: 'gray' }} />Save for later</Typography>
                                    <Button
                                        variant="outlined"
                                        color="error"
                                        size="small"
                                        onClick={() => handleDelete(item.id)}
                                        sx={{ textTransform: 'none' }}
                                    >
                                        <DeleteIcon sx={{ fontSize: '20px' }} /> Delete
                                    </Button>
                                </Box>
                            </Card>
                        ))}

                        <Card sx={{ p: 2, borderRadius: 2, boxShadow: 2 }}>
                            <Typography variant="h6" fontWeight="bold" gutterBottom>
                                Your Items
                            </Typography>
                            <ToggleButtonGroup
                                value={toggle}
                                exclusive
                                onChange={(e, newToggle) => {
                                    if (newToggle !== null) setToggle(newToggle);
                                }}
                                sx={{ mb: 2 }}
                            >
                                <ToggleButton value="save">Save for later</ToggleButton>
                                <ToggleButton value="buy">Buy it again</ToggleButton>
                            </ToggleButtonGroup>

                            {(toggle === 'save' ? saveForLaterItems : buyItAgainItems).map((item) => (
                                <Box
                                    sx={{
                                        display: 'grid',
                                        gridTemplateColumns: {
                                            xs: 'repeat(1, 1fr)',
                                            sm: 'repeat(2, 1fr)',
                                            md: 'repeat(4, 1fr)',
                                        },
                                        gap: 2,
                                    }}
                                >
                                    <Card
                                        key={item.id}
                                        sx={{
                                            borderRadius: 2,
                                            boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
                                            transition: 'transform 0.2s ease-in-out',
                                            '&:hover': {
                                                transform: 'translateY(-5px)',
                                                boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
                                            },
                                            border: '1px solid #CBCBCB'
                                        }}
                                    >
                                        <CardMedia
                                            component="img"
                                            image={item.image}
                                            alt={`product-AED{index}`}
                                            sx={{ height: 180, objectFit: 'cover' }}
                                        />
                                        <CardContent sx={{ p: 2 }}>
                                            {/* Discount Badge */}
                                            <Box
                                                sx={{
                                                    backgroundColor: '#ffe5e5',
                                                    color: '#d32f2f',
                                                    fontWeight: 'bold',
                                                    fontSize: '12px',
                                                    display: 'inline-block',
                                                    px: 1.5,
                                                    py: 0.5,
                                                    borderRadius: 1,
                                                    mb: 1,
                                                }}
                                            >
                                                {item.discount}
                                            </Box>

                                            {/* Price Section */}
                                            <Box sx={{ alignItems: 'center', gap: 1, mb: 1 }}>
                                                <Typography sx={{ fontWeight: 'bold', fontSize: '18px', color: '#C32032' }}>
                                                    {item.price}
                                                </Typography>
                                                <Typography
                                                    sx={{
                                                        fontSize: '14px',
                                                        color: '#888',
                                                        textDecoration: 'line-through',
                                                    }}
                                                >
                                                    {item.oldPrice}
                                                </Typography>
                                            </Box>

                                            {/* Product Info */}
                                            <Typography sx={{ fontWeight: 500, fontSize: '14px', mb: 0.5 }}>
                                                {item.name}
                                            </Typography>
                                            <Typography sx={{ fontSize: '13px', color: '#555', mb: 1 }}>
                                                {item.size}
                                            </Typography>
                                            <Button sx={{ width: '100%', border: '1px solid #CBCBCB', color: 'gray', borderRadius: '25px', textTransform: 'none' }}>Move to Cart</Button>
                                        </CardContent>
                                    </Card>
                                </Box>
                            ))}
                        </Card>
                    </Box>
                    {/* end cart items */}

                    {/* Right card for Order Summary */}
                    <Box sx={{ flex: 1, mb: 2 }}>
                        <Stack spacing={2}>

                            {/* Delivery Options Card */}
                            <Card sx={{ p: 2 }}>
                                <Typography variant="h6" sx={{ fontWeight: "bold", mb: 2 }}>
                                    Delivery Options
                                </Typography>

                                {deliveryoptions.map((option, index) => (
                                    <Box key={option.value}>
                                        <Box
                                            display="flex"
                                            justifyContent="space-between"
                                            alignItems="center"
                                            onClick={() => setSelectedDeliveryOption(option.value)}
                                            sx={{
                                                cursor: "pointer",
                                                py: 1,
                                                "&:hover": { backgroundColor: "#f5f5f5" },
                                            }}
                                        >
                                            <Box display="flex" alignItems="flex-start">
                                                <Radio
                                                    checked={deliveryselectedOption === option.value}
                                                    value={option.value}
                                                    sx={{ mt: 0.5 }}
                                                />
                                                <Box>
                                                    <Typography fontWeight="bold">{option.label}</Typography>
                                                    <Typography variant="body2" color="text.secondary">
                                                        {option.subLabel}
                                                    </Typography>
                                                </Box>
                                            </Box>

                                            <Typography fontWeight="bold" color={'#C32032'} whiteSpace="nowrap">
                                                {option.price}
                                            </Typography>
                                        </Box>

                                        {index < deliveryoptions.length - 1 && <Divider />}
                                    </Box>
                                ))}
                            </Card>

                            {/* Apply coupon */}
                            <Card sx={{ p: 2, borderRadius: 2, boxShadow: 2 }}>
                                <Typography variant="h6" fontWeight="bold" mb={2}>
                                    Discount Code
                                </Typography>
                                <Box sx={{ display: 'flex', justifyContent: 'space-between', gap: 1 }}>
                                    <TextField label="Coupon Code" fullWidth placeholder='Enter code (try fortune5, welcome etc.,)' />
                                    <Button sx={{ background: '#C32032', color: '#fff', width: '30%', textTransform: 'none' }}>Apply</Button>
                                </Box>
                            </Card>

                            {/* Order summary */}
                            <Card sx={{ p: 2, borderRadius: 2, boxShadow: 2 }}>
                                <Typography variant="h6" fontWeight="bold" mb={2}>
                                    Order Summary
                                </Typography>
                                <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                    <Typography>Items ({items.length})</Typography>
                                    <Typography>
                                        AED{items.reduce((acc, item) => acc + item.price * item.quantity, 0).toFixed(2)}
                                    </Typography>
                                </Box>
                                <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                    <Typography>Shipping</Typography>
                                    <Typography>
                                        FREE
                                    </Typography>
                                </Box>
                                <Divider sx={{ mt: 2, mb: 2 }} />
                                <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                    <Typography fontSize={18} fontWeight="bold">Order Total</Typography>
                                    <Typography sx={{ fontWeight: 'bold', fontSize: '18px', color: '#C32032' }}>
                                        AED{items.reduce((acc, item) => acc + item.price * item.quantity, 0).toFixed(2)}
                                    </Typography>
                                </Box>
                                <Divider sx={{ mt: 2, mb: 2 }} />
                                <Box>
                                    <Typography fontSize={18} fontWeight="bold">Delivery Address</Typography>
                                </Box>
                                <Box display={'flex'} justifyContent={'space-between'}>
                                    <Typography sx={{ width: '60%' }}>Villa 25, Street 12B, Al Barsha 2
                                        Near Al Barsha Mall
                                        Dubai, United Arab Emirates<br />
                                        ph.no: 123 456 7890  </Typography>
                                    <Button sx={{ background: '#C32032', color: '#fff', height: '100%' }} onClick={() => setChangeAddress(true)}>Change</Button>
                                </Box>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    fullWidth
                                    sx={{ mt: 2, backgroundColor: '#C32032', '&:hover': { backgroundColor: '#a71a28' }, display: 'flex', alignItems: 'center', gap: '3px', textTransform: 'none', fontSize: '18px' }}
                                    onClick={() => navigate('/confirm-order')}
                                >
                                    Proceed to Checkout<EastIcon />
                                </Button>
                            </Card>

                        </Stack>
                    </Box>
                    {/* end order summary */}
                </Box>
                {/*  */}

                {/* recommended for you */}
                <Box sx={{ p: 2, mt: 4 }}>

                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Typography
                            sx={{
                                color: '#000',
                                fontSize: '20px',
                                fontWeight: 'bold',
                                mb: 2,
                                display: 'flex', gap: '5px', alignItems: 'center'
                            }}
                        >
                            Recommended for you
                        </Typography>

                        <Typography className="see-all-link"
                            sx={{
                                fontSize: '14px',
                                '&:hover': {
                                    textDecoration: 'underline',
                                },
                            }}
                            onClick={() => navigate('/products')}
                        >
                            See All
                        </Typography>
                    </Box>

                    <Box
                        sx={{
                            display: 'grid',
                            gridTemplateColumns: {
                                xs: 'repeat(1, 1fr)',
                                sm: 'repeat(2, 1fr)',
                                md: 'repeat(5, 1fr)',
                            },
                            gap: 2,
                        }}
                    >
                        {dealsProduct.map((product, index) => (
                            <Card
                                key={index}
                                sx={{
                                    borderRadius: 2,
                                    boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
                                    transition: 'transform 0.2s ease-in-out',
                                    '&:hover': {
                                        transform: 'translateY(-5px)',
                                        boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
                                    },
                                    border: '1px solid #CBCBCB'
                                }}
                            >
                                <CardMedia
                                    component="img"
                                    image={product.image}
                                    alt={`product-AED{index}`}
                                    sx={{ height: 180, objectFit: 'cover' }}
                                />
                                <CardContent sx={{ p: 2 }}>
                                    {/* Discount Badge */}
                                    <Box
                                        sx={{
                                            backgroundColor: '#ffe5e5',
                                            color: '#d32f2f',
                                            fontWeight: 'bold',
                                            fontSize: '12px',
                                            display: 'inline-block',
                                            px: 1.5,
                                            py: 0.5,
                                            borderRadius: 1,
                                            mb: 1,
                                        }}
                                    >
                                        {product.discount}
                                    </Box>

                                    {/* Price Section */}
                                    <Box sx={{ alignItems: 'center', gap: 1, mb: 1 }}>
                                        <Typography sx={{ fontWeight: 'bold', fontSize: '18px', color: '#C32032' }}>
                                            {product.price}
                                        </Typography>
                                        <Typography
                                            sx={{
                                                fontSize: '14px',
                                                color: '#888',
                                                textDecoration: 'line-through',
                                            }}
                                        >
                                            {product.oldPrice}
                                        </Typography>
                                    </Box>

                                    {/* Product Info */}
                                    <Typography sx={{ fontWeight: 500, fontSize: '14px', mb: 0.5 }}>
                                        {product.title}
                                    </Typography>
                                    <Typography sx={{ fontSize: '13px', color: '#555', mb: 1 }}>
                                        {product.size}
                                    </Typography>

                                    {/* Countdown */}
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            height="18"
                                            viewBox="0 0 24 24"
                                            width="18"
                                            fill="#888"
                                        >
                                            <path d="M0 0h24v24H0z" fill="none" />
                                            <path d="M12 1a11 11 0 1011 11A11 11 0 0012 1zm0 20a9 9 0 119-9 9 9 0 01-9 9zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z" />
                                        </svg>
                                        <Typography sx={{ fontSize: '13px', color: '#555' }}>
                                            Ends in: {product.endsIn}
                                        </Typography>
                                    </Box>
                                </CardContent>
                            </Card>
                        ))}
                    </Box>
                </Box>
                {/*  */}
            </Box>
            {/* end body section */}
            {/* Modal Popups */}

            {/* choose address popup */}
            <Modal open={changeAddress} onClose={() => setChangeAddress(false)}>
                <Box sx={style}>
                    <Typography variant='h6'>Select Address</Typography>
                    <Divider sx={{ mb: 2 }} />
                    {[
                        {
                            id: 1,
                            name: 'John Doe',
                            address: 'Villa 25, Street 12B,\n Al Barsha 2 Near Al Barsha Mall Dubai,\nUnited Arab Emirates',
                            phone: '+91 123 456 7890',
                            tag: 'Home',
                            isDefault: true
                        },
                        {
                            id: 2,
                            name: 'Jane Smith',
                            address: '456 Avenue Road, Town, State - 654321',
                            phone: '+91 9123456780',
                            tag: 'Work',
                            isDefault: false
                        },
                    ].map((addr) => (
                        <Card key={addr.id} sx={{
                            mb: 2,
                            p: 2,
                            borderRadius: 2,
                            boxShadow: 2,
                            transition: '0.3s',
                            border: '1px solid transparent',
                            cursor: 'pointer',
                            '&:hover': {
                                border: '1px solid #C32032',
                            },
                        }}>
                            <Box display="flex" justifyContent="space-between" alignItems="flex-start" mb={1}>
                                <Typography variant="subtitle1" fontWeight={600} sx={{ alignItems: 'center', display: 'flex' }}>
                                    <LocationOnIcon fontSize="small" sx={{ mr: 0.5 }} />
                                    {addr.tag}{addr.isDefault && <Chip label="Default" size="small" sx={{ ml: 1, background: '#ffe5e5', color: '#d32f2f', width: '72px' }} />}
                                </Typography>
                            </Box>

                            <Divider sx={{ mb: 1 }} />
                            <Typography variant="body2" mb={0.5}>{addr.address}</Typography>
                            <Typography variant="body2">Phone: {addr.phone}</Typography>
                        </Card>
                    ))}

                    <Box sx={{ display: 'flex', justifyContent: 'right' }}>
                        <Button sx={{ background: '#C32032', color: '#fff' }} onClick={() => { setNewAddress(true); setChangeAddress(false); }}><AddIcon /> New Address</Button>
                    </Box>
                </Box>
            </Modal>

            {/* adding new address popup */}
            <Modal open={newaddress} onClose={() => setNewAddress(false)}>
                <Box sx={style}>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                        <TextField label="Address Name" fullWidth placeholder="e.g.Home, work etc.," />
                        <TextField label="Street Address" fullWidth placeholder="street name, house number etc.," />
                        <TextField label="City" fullWidth />
                        <TextField label="Postal Code" fullWidth />
                        <TextField label="Country" fullWidth />
                        <TextField label="Phone Number" fullWidth />
                        <Typography sx={{ display: 'flex', gap: '5px', alignItems: 'center' }}><CheckBox />Set as default address</Typography>
                        <Box sx={{ display: 'flex', gap: '5px' }}>
                            <Button variant="contained" sx={{ backgroundColor: '#C32032', fontWeight: 'bold', textTransform: 'none' }} onClick={() => setNewAddress(false)}>
                                Save Address
                            </Button>
                            <Button variant="outlined" sx={{ border: '1px solid #C32032', fontWeight: 'bold', textTransform: 'none', color: '#C32032' }} onClick={() => setNewAddress(false)}>
                                Close
                            </Button>
                        </Box>
                    </Box>
                </Box>
            </Modal>

            {/* end modal popups */}

            {/* footer */}
            <Footer />
            {/* end footer */}
        </>
    );
}

export default Cart;